import React from 'react'
import  Banner from '../Banner'

export const Home = () => {
  return (
    <div><Banner/></div>
  )
}
